(function () {
  // CookieYes opens its consent UI on any .cky-banner-element click, but does not cancel
  // navigation; only cancel it when CookieYes has actually rendered its UI, so visitors
  // still follow the link if the banner failed to load. The tag is matched rather than an
  // element id because the GDPR template names the modal "detail" and the US-state-law
  // template names it "optout-popup".
  const CONSENT_UI_SELECTOR = '[data-cky-tag="detail"], [data-cky-tag="optout-popup"]';

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a.cky-banner-element');
    if (link && document.querySelector(CONSENT_UI_SELECTOR)) {
      event.preventDefault();
    }
  });

  // Forward the CookieYes decision to Shopify's Customer Privacy API so app pixels
  // (Meta, Clarity, Google, TikTok, Reddit) receive the opt-out. Without this, CookieYes
  // and Shopify consent never talk to each other. Under the opt-in banner an undecided
  // visitor is pushed as an explicit deny, so nothing rides on Shopify's own region
  // config being right.
  function pushConsentToShopify() {
    if (typeof window.getCkyConsent !== 'function') return;
    const consent = window.getCkyConsent();
    const decided = consent.isUserActionCompleted === true;
    const analytics = decided && consent.categories.analytics === true;
    const advertisement = decided && consent.categories.advertisement === true;
    const functional = decided && consent.categories.functional === true;
    withCustomerPrivacy(function (customerPrivacy) {
      customerPrivacy.setTrackingConsent(
        {
          analytics: analytics,
          marketing: advertisement,
          preferences: functional,
          sale_of_data: advertisement,
        },
        function () {}
      );
    });
  }

  function withCustomerPrivacy(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      callback(window.Shopify.customerPrivacy);
      return;
    }
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error && window.Shopify.customerPrivacy) callback(window.Shopify.customerPrivacy);
      });
    }
  }

  document.addEventListener('cookieyes_consent_update', pushConsentToShopify);
  document.addEventListener('cookieyes_banner_load', pushConsentToShopify);
})();
